import { Brands } from '../../../config/brands';
import mainTheme from '../theme';

const theme = {
  ...mainTheme,
  name: Brands.DZD,
  COLORS: {
    ...mainTheme.COLORS,
    primary: '#A81524',
    secondary: '#A81524',
  },
};

export default theme;
